import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let question_id = useDataValue({
    context: 'selected',
    path: 'question_id',
    viewPath: props.viewPath,
  })

  let question_type_id = useDataValue({
    context: 'selected',
    path: 'question_type_id',
    viewPath: props.viewPath,
  })

  let question_template = useDataValue({
    context: 'selected',
    path: 'question_template',
    viewPath: props.viewPath,
  })

  let configuration_id = useDataValue({
    context: 'selected',
    path: 'configuration_id',
    viewPath: props.viewPath,
  })

  let questions = useDataValue({
    viewPath: props.viewPath,
    context: 'questions',
  })

  return useMemo(() => {
    if (!data || !question_id) return data

    if (question_id === 'new' && question_type_id === 'custom') {
      return {
        id: undefined,
        name: null,
        prompt: null,
        subprompt: null,
        type: 'text',
        options: null,
        external_resource: null,
        resource_id: null,
        resource_schema: null,
        resource_table: null,
        order: questions.length + 1,
        required: false,
        status: 'active',
        depends_on: null,
        configuration_id: configuration_id,
      }
    }

    if (question_id === 'new' && question_type_id !== 'custom') {
      let { text, ...question } = question_template
      return {
        ...question,
        id: undefined,
        status: 'active',
        prompt: question.resource_schema !== 'leads' ? text : null,
        order: questions.length + 1,
        configuration_id: configuration_id,
      }
    }

    let question_edit = questions.find(question => question.id === question_id)

    if (question_edit) {
      return {
        ...question_edit,
        options: Array.isArray(question_edit.options)
          ? question_edit.options.join(',')
          : question_edit.options,
        depends_on: question_edit.depends_on
          ? [...question_edit.depends_on]
          : null,
      }
    }

    return data
  }, [
    data,
    question_id,
    questions,
    configuration_id,
    question_type_id,
    question_template,
  ])
}
